<script>
import ActionBar from '@/components/core/ActionBar.vue';

export default {
  extends: ActionBar,
  data() {
    return {
      resourceName: 'PlantUser',
      urlFragment: 'plant-users',
    };
  },
};
</script>

<style></style>
